import { makeStyles } from '@mui/styles';
const drawerWidth = 260;
export const useStyles = makeStyles(theme => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    background: theme.colors.dark.darkBlue,
    [theme.breakpoints.down('sm')]: {
      padding: 10,
      paddingTop: 20,
    },
  },
  bottomContainer: {
    background: theme.colors.light.lightSteelBlue,
    marginRight: -15,
    marginLeft: -15,
    marginTop: 'revert',
  },
  drawerContainer: {
    overflow: 'auto',
    padding: '15px 15px 0 15px',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  drawerItem: {
    color: theme.colors.light.freshPowder,
  },
  root: {
    '&.MuiListItem-root': {
      paddingBottom: 5,
      paddingTop: 5,
    },
  },
}));
